import React from "react";
import { Paper, Stack, Typography, Box } from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { useNavigate } from "react-router-dom";

import AlertColumn from "./AlertColumn";
import InfoButton from "./InfoButton";
import { HELP_CONTENT } from "../../constants/clinicalHelpContent";

/**
 * Panel 2: Real-Time Alerts
 * 3 columnas (admitted/discharged/emergency) con layout flex.
 */
export default function PanelAlerts({ alerts, loading, onCreateTask }) {
  const navigate = useNavigate();

  const counts = alerts?.counts || {};

  const handleViewAll = (type) => {
    navigate(`/PatientMap?segment=${type}`);
  };

  const handlePatientClick = (patient) => {
    navigate(`/ClinicalInfo?cipId=${patient.cipId}`);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        {/* Panel header */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 28,
              height: 28,
              borderRadius: 1.5,
              bgcolor: "#FEE2E2",
              color: "#DC2626",
            }}
          >
            <NotificationsActiveIcon sx={{ fontSize: 16 }} />
          </Box>
          <Typography variant="subtitle2" fontWeight={700}>
            Real-Time Alerts
          </Typography>
          <InfoButton helpContent={HELP_CONTENT.alerts} />
        </Stack>

        {/* 3 Columns */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          divider={
            <Box
              sx={{
                display: { xs: "none", md: "block" },
                borderLeft: "1px solid",
                borderColor: "divider",
              }}
            />
          }
        >
          <AlertColumn
            type="admitted"
            patients={alerts?.admitted}
            count={counts.admitted}
            loading={loading}
            onViewAll={() => handleViewAll("admitted")}
            onPatientClick={handlePatientClick}
            onCreateTask={onCreateTask}
          />
          <AlertColumn
            type="discharged"
            patients={alerts?.discharged}
            count={counts.discharged}
            loading={loading}
            onViewAll={() => handleViewAll("discharged")}
            onPatientClick={handlePatientClick}
            onCreateTask={onCreateTask}
          />
          <AlertColumn
            type="emergency"
            patients={alerts?.emergency}
            count={counts.emergency}
            loading={loading}
            onViewAll={() => handleViewAll("emergency")}
            onPatientClick={handlePatientClick}
            onCreateTask={onCreateTask}
          />
        </Stack>
      </Stack>
    </Paper>
  );
}
